import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const FlexClassName = `${CLASS_NAME_PREFIX}-flex`;
